<i *ngIf="selected" class="material-icons">done</i>
